module.exports = __webpack_public_path__ + "img/people-type.svg";